import { Controller } from '@hotwired/stimulus'

export default class UserGroupFormController extends Controller {
  static targets = ['users', 'children', 'isParent']

  connect() {
    this.toggleAssociationInputs()
  }

  toggleAssociationInputs() {
    const isParent = this.isParentTarget.checked

    this.usersTarget.classList.toggle('d-none', isParent)
    this.childrenTarget.classList.toggle('d-none', !isParent)
  }
}
